import {
  LOGIN_API_URL
} from "../utils/Constant";


// import {LOGIN_API_URL} from './Constant';

// async function loginUser() {
//   try {
//     let email = 'wes@gmail.com';
//     let password = 'wes@123*';
//     const response = await fetch(LOGIN_API_URL, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         email,
//         password,
//       }),
//     });

//     const data = await response.json();

//     return data.data.token; // Assuming the token is available in the response
//   } catch (error) {
//     console.error('Login Error:', error.message);
//     throw error; // Rethrow the error for handling in the calling function
//   }
// }

// export default loginUser;

import axios from 'axios';

const api = axios.create({
  baseURL: LOGIN_API_URL,
  // Add any additional configurations as needed (headers, interceptors, etc.)
});

export default api;

